module.exports = "<ui-gmap-polylines *ngIf=\"polylines.length > 0\" [polylines]=polylines></ui-gmap-polylines> ";